import React, { Component } from 'react';
import { Button } from 'reactstrap';
import withBackgroundImage from '../../HOC/withBackgroundImage';

import './TimeOut.scss';

class TimeOutContainer extends Component {
  render() {
    return (
      <div className="time-out">
        <h1>Sorry, your session timed out.</h1>
        <p className="heading">For your security, we ended your application. Please start over.</p>

        <div className="button-background">
          <Button size="lg" color="primary" href="/">Restart application</Button>         
          <Button size="lg"color="primary" href="https://www.vancity.com">Go to vancity.com</Button>      
        </div>
      </div>
    );
  }
}



export default withBackgroundImage("time-out")(TimeOutContainer);


// WEBPACK FOOTER //
// ./src/containers/TimeOut/TimeOut.js